import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import { api } from '../services/api';

/**
 * Lien court reçu par SMS (/l/:code) : échangé contre le jeton de session, puis page de signature.
 */
function LinkRedirect() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    api.post('/session/resolve', { code })
      .then((response) => {
        if (!cancelled) navigate(`/s/${response.data.token}`, { replace: true });
      })
      .catch(() => {
        if (!cancelled) navigate('/error', { replace: true });
      });
    return () => { cancelled = true; };
  }, [code, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <LoadingSpinner />
    </div>
  );
}

export default LinkRedirect;
